import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4ktjmwa4: FaireBrandEntity = {
  token: "b_4ktjmwa4",
  type: "brand",
  name: "Urban Baby Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/fbc082985c2982270da6b12742d00580fe5b55d2ea0986f7a3e483e8e35a3f67.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1f207ddc9e247006ef6a6516df60f7bcc1bd3a694196437e050b305820cc0c85.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/fbc082985c2982270da6b12742d00580fe5b55d2ea0986f7a3e483e8e35a3f67.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1f207ddc9e247006ef6a6516df60f7bcc1bd3a694196437e050b305820cc0c85.jpeg",
  location: "Denver, CO, USA",
  minimumOrderDollars: 250,
  rating: 5,
  reviewCount: 17,
  isInsider: true,
  description:
    "Urban Baby Co. is an eclectic, eco-friendly, and handmade brand for the hippest babies and toddlers. Our modern, fashion-forward styles will meet the approval of today's most trendsetting folks. With looks ranging from soft and sweet to sarcastic and funny, all of our goods are custom designed making them unique and truly one-of-a-kind. Using 100% organic cotton, recycled materials, and biodegradable packaging, we strive to be green in all facets of our business.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:25.411Z",
    importedBy: "entity-db-cli",
  },
};
